import React, { useState } from "react";
import axios from "axios";
import "./vote.css";

export default function VotePage() {
  const [username, setUsername] = useState("");
  const [status, setStatus] = useState("");

  const handleVote = async () => {
    if (!username) {
      setStatus("❌ Please enter your Minecraft username");
      return;
    }
    const checkStatus = async () => {
    const res = await axios.get(`http://localhost/api/checkVote.php?username=${username}`);
    
    if (res.data.claim) {
        setStatus("✅ Reward ready! Join server!");
    }
    };
    
    try {
      setStatus("⏳ Sending vote...");

      const res = await axios.post("https://vortexnetowrknew.co.uk/php-backend/vote.php", {
        username: username,
      });

      if (res.data.success) {
        setStatus("✅ Vote successful! Wait 3 minutes then claim in-game.");
      } else {
        setStatus("❌ " + res.data.message);
      }
    } catch (err) {
      setStatus("❌ Server error");
    }
  };

  return (
    <div className="vote-container">
      <div className="vote-card">
        <h1>🌐 Vortex Network</h1>
        <p>Vote for rewards!</p>

        <input
          type="text"
          placeholder="Enter Minecraft Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <button onClick={handleVote}>Vote Now</button>

        {status && <p className="status">{status}</p>}
      </div>
    </div>
  );
}